export const closeFilterTag = (controller, doNotGroup, singlePredicate, filterName, index, value) => {
  if (controller && doNotGroup) {
    const value = controller.predicate();
    if (!singlePredicate) {
      const filteredArray = value.map((obj) => {
        if (obj.field === filterName) {
          const filteredValues = obj.values.filter((_, i) => i !== index);
          return { ...obj, values: filteredValues };
        }
        return obj;
      });
      controller.updateDefaultValues(filteredArray);
    } else {
      const newValues = value.filter((v) => filterName !== v.field);
      controller.updateDefaultValues(newValues);
    }
  } else {
    const newValues = value.filter((v) => filterName !== v.field);
    controller.updateDefaultValues(newValues);
  }
};
